// Google Analytics dataLayer bootstrap. Loaded synchronously in index.html so
// gtag() is callable before the async gtag.js loader resolves and replays.
window.dataLayer = window.dataLayer || [];
function gtag() { dataLayer.push(arguments); }
// Record production traffic only. Local Playwright runs (127.0.0.1), dev.
// and pages.dev previews were showing up in GA as real users. gtag stays
// defined so trackEvent() calls remain safe no-ops.
if (!/^(www\.)?konsacard\.pk$/.test(location.hostname)) window["ga-disable-G-8D8HRYPVY6"] = true;
gtag("js", new Date());
gtag("config", "G-8D8HRYPVY6");
